import { Action, createAction, createReducer, createSelector, on, props } from '@ngrx/store';
import { State as AppState } from '../../state';

export const setIsDesktop = createAction('[Sidebar] Set Is Desktop', props<{isDesktop: boolean}>());

export const openModal = createAction('[Sidebar] Open Modal');
export const closeModal = createAction('[Sidebar] Close Modal');

export const donateClicked = createAction('[Donate] Donate Clicked', props<{donateUrl}>());
export const pdfClicked = createAction('[Reading] PDF Clicked', props<{pdfUrl}>());

export interface State {
	isDesktop: boolean;
	modalIsOpen: boolean;
}
export const initialState: State = {
	isDesktop: false,
	modalIsOpen: false,
};

export const uiReducer = createReducer(
	initialState,
	on(setIsDesktop, (state, action) => ({...state, isDesktop: action.isDesktop})),
	on(openModal, (state) => ({...state, modalIsOpen: true})),
	on(closeModal, (state) => ({...state, modalIsOpen: false}))
);

export function reducer(state: State|undefined, action: Action) {
	return uiReducer(state, action);
}

export const selectModalStatus = createSelector(
	(state: AppState) => state.ui,
	ui => ui.modalIsOpen
);
